export default __webpack_public_path__ + "static/media/tool-item-h5-blue-bg4.e0685dc1.png";